export enum LanguageEnum {
    IT = 'IT',
    EN = 'EN',
    DE = 'DE',
    FR = 'FR',
}
